import { render, staticRenderFns } from "./fatura.vue?vue&type=template&id=b62135c2"
import script from "./fatura.vue?vue&type=script&lang=js"
export * from "./fatura.vue?vue&type=script&lang=js"
import style0 from "./fatura.vue?vue&type=style&index=0&id=b62135c2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports